module.exports = __webpack_public_path__ + "img/bandicam_00014.9b0588ea.png";